import Box from '@cloudscape-design/components/box';
import ExpandableSection from '@cloudscape-design/components/expandable-section';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Table from '@cloudscape-design/components/table';
import React, { useState } from 'react';
import { ParticipantDetails } from './ParticipantDetails';

export interface Participant {
    ParticipantID: string;
    ChestNum: string;
    FirstName: string;
    LastName: string;
    GradeCategory: string;
    ParticipantPhoneNumber: string;
    GuardianPhoneNumber: string;
}

interface ParticipantsProps {
    participants: Participant[]
}

export const Participants: React.FC<ParticipantsProps> = ({
    participants
}) => {
    const [
        selectedItems,
        setSelectedItems
    ] = useState<Participant[]>();

    return (
        <ExpandableSection
            defaultExpanded
            variant="container"
            headerText="Participants"
        >
            <SpaceBetween size='l'>
                <Table
                    selectionType='single'
                    onSelectionChange={({ detail }) =>
                        setSelectedItems(detail.selectedItems)
                    }
                    selectedItems={selectedItems}
                    columnDefinitions={[
                        {
                            id: "chestNumber",
                            header: "Chest Number",
                            cell: item => item.ChestNum || "-",
                            sortingField: "name",
                            isRowHeader: true,
                        },
                        {
                            id: "firstName",
                            header: "First Name",
                            cell: item => item.FirstName || "-",
                            sortingField: "alt"
                        },
                        {
                            id: "lastName",
                            header: "Last Name",
                            cell: item => item.LastName || "-"
                        },
                        {
                            id: "grade",
                            header: "Grade",
                            cell: item => item.GradeCategory || "-"
                        },
                        {
                            id: "participantPhoneNumber",
                            header: "Participant Phone Number",
                            cell: item => item.ParticipantPhoneNumber || "-"
                        },
                        {
                            id: "guardianphoneNumber",
                            header: "Guardian Phone Number",
                            cell: item => item.GuardianPhoneNumber || "-"
                        }
                    ]}
                    items={participants}
                    loadingText="Loading event details"
                    sortingDisabled
                    empty={
                        <Box
                            margin={{ vertical: "xs" }}
                            textAlign="center"
                            color="inherit"
                        >
                            <SpaceBetween size="m">
                                <b>No details found</b>
                            </SpaceBetween>
                        </Box>
                    }
                />
                {
                    selectedItems && ( <ParticipantDetails participant={selectedItems[0]} />)
                }
            </SpaceBetween>
        </ExpandableSection>
    )
};